import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import UserHeader from "../UserHeader/UserHeader";
import UserContent from "../UserContent/UserContent";
import UserFooter from "../UserFooter/UserFooter";
import "./usertabs.scss";
import MentorHeader from "../../Mentors/MentorHeader/MentorHeader";
import MentorContent from "../../Mentors/MentorContent/MentorContent";
import MentorFooter from "../../Mentors/MentorFooter/MentorFooter";
import {
  RootStore,
  useAppSelector,
  useAppDispatch,
} from "../../../../store/store";
import { Domain } from "../../../../helpers/utils/DomainSwitcher/domains";
import axiosInstance from "../../../../apiConfigs/axiosInstance";
import { renderDynamicUrlFromComponentLevelState } from "../../../../helpers/utils/urlHelper";
import TrialUserHeader from "../TrialUser/TrialUserHeader/TrialUserHeader";
import TrialUserContent from "../TrialUser/TrialUserContent/TrialUserContent";
import Subscribers from "../../../../pages/AdminPanel/Subscribers/Subscribers";
import ApplyNow from "../../../../pages/AdminPanel/ApplyNow/ApplyNow";
import SubAdminHeader from "../../SubAdmin/SubAdminHeader/SubAdminHeader";
import SubAdminContent from "../../SubAdmin/SubAdminContent/SubAdminContent";
import SubAdminFooter from "../../SubAdmin/SubAdminFooter/SubAdminFooter";
import DeleteModal from "../../../../shared/DeleteModal/DeleteModal";
import {
  deleteMultipleUsers,
  loadUsers,
} from "../../../../store/features/AdminPanel/User/UserApi";
import TrialUserFooter from "../TrialUser/TrialUserFooter/TrialUserFooter";
import {
  setCurrentPage,
  setTrialUserCurrentPage,
} from "../../../../store/features/AdminPanel/User/UserSlice";
import { setMentorCurrentPage } from "../../../../store/features/AdminPanel/Mentor/MentorSlice";
import { setSubadminCurrentPage } from "../../../../store/features/AdminPanel/SubAdmin/SubAdminSlice";
import SelfPacedUserHeader from "../SelfPacedUser/SelfPacedUserHeader/SelfPacedUserHeader";
import SelfPacedUserContent from "../SelfPacedUser/SelfPacedUserContent/SelfPacedUserContent";
import SelfPacedUserFooter from "../SelfPacedUser/SelfPacedUserFooter/SelfPacedUserFooter";
import LiveDataAaystNotifiedUsers from "../LiveDataAnalystNotifiedUsers/LiveDataAaystNotifiedUsers";
import { setSelfPacedCurrentPage } from "../../../../store/features/AdminPanel/SelfPacedUser/SelfPacedUserSlice";

const selfPacedUserRoles = [
  "self_paced_product_manager",
  "self_paced_scrum_master",
  "self_paced_agile_project_manager",
  "self_paced_product_owner",
  "self_paced_business_analyst",
];

const freeUserRoles = [
  "free_self_paced_business_analyst",
  "free_self_paced_product_owner",
];

const UserAllTabs = () => {
  const dispatch = useAppDispatch();
  const [tabIndex, setTabIndex] = useState(0);
  const [selfPacedTabIndex, setSelfPacedTabIndex] = useState(0);
  const [downloadCsvLoading, setDownloadCsvLoading] = useState(false);
  const [showSelectCheckbox, setShowSelectCheckbox] = useState(false);
  const [deleteAllUserModal, setDeleteAllUserModal] = useState(false);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const [checkedUsers, setCheckedUsers] = useState<number[]>([]);
  const location: any = useLocation();

  const configState: any = useAppSelector((store: RootStore) => {
    return store.ThemeSlice;
  });

  const downloadSampleCsv = async () => {
    setDownloadCsvLoading(true);
    const dynamic_url = renderDynamicUrlFromComponentLevelState(configState);

    await axiosInstance.get(`${dynamic_url}/get-sample-csv-url`).then((res) => {
      window.location.href = res.data.data;
    });
    setDownloadCsvLoading(false);
  };

  useEffect(() => {
    if (location?.state?.tag === "apply-now") {
      setTabIndex(6);
    }
  }, [location?.state?.tag]);

  const handleCheckboxChange = (e: any, userId: number) => {
    e.stopPropagation();
    if (checkedUsers.includes(userId)) {
      // Remove the userId if already checked
      setCheckedUsers((prev) => prev.filter((id) => id !== userId));
    } else {
      // Add the userId if not checked
      setCheckedUsers((prev) => [...prev, userId]);
    }
  };

  const userState: any = useAppSelector((store: RootStore) => {
    return store.UserSlice;
  });

  const handleCurrentPage = (index: number) => {
    dispatch(setCurrentPage(1));
    dispatch(setMentorCurrentPage(1));
    dispatch(setTrialUserCurrentPage(1));
    dispatch(setSubadminCurrentPage(1));
    setTabIndex(index);
  };

  useEffect(() => {
    if (!userState.deleteLoading && userState.delete_success) {
      setDeleteAllUserModal(false);
    }
  }, [userState]);

  const handleSelectAllChange = () => {
    if (selectAllChecked) {
      // Uncheck all users
      setCheckedUsers([]);
    } else {
      // Check all users
      const allUserIds = userState.users.map((question: any) => question.id);
      setCheckedUsers(allUserIds);
    }

    // Toggle the state of "Select All" checkbox
    setSelectAllChecked((prev) => !prev);
  };

  const deleteUser = () => {
    dispatch(deleteMultipleUsers({ ids: checkedUsers })).then(() => {
      setShowSelectCheckbox(false);
      setCheckedUsers([]);
    });
  };

  const isActiveDeleteAllUsers =
    showSelectCheckbox && checkedUsers?.length !== 0;

  return (
    <div className="user__tabs__container mt-7">
      <Tabs
        className="user__tab__container"
        selectedIndex={tabIndex}
        onSelect={(index) => handleCurrentPage(index)}
      >
        <TabList className="user__tab__list__section">
          <Tab className="user__single__tab ">All Users</Tab>
          <Tab className="user__single__tab mll">Sub-Admin</Tab>

          {configState.configs?.membership_enabled === Domain.TAA && (
            <>
              {" "}
              <Tab className="user__single__tab mll">Self Paced Users</Tab>
              <Tab className="user__single__tab mll">All Mentors</Tab>
              <Tab className="user__single__tab mll">Trial Users</Tab>
              <Tab className="user__single__tab mll">Subscribers</Tab>
              <Tab className="user__single__tab mll">Apply Now</Tab>
              {/* <Tab className="user__single__tab mll">Live Data Analyst Notified Users</Tab> */}
            </>
          )}
        </TabList>
        <TabPanel>
          <div className="box__shadow">
            <UserHeader
              downloadSampleCsv={downloadSampleCsv}
              downloadCsvLoading={downloadCsvLoading}
              showSelectCheckbox={showSelectCheckbox}
              setShowSelectCheckbox={setShowSelectCheckbox}
              setDeleteAllUserModal={setDeleteAllUserModal}
              checkedUsers={checkedUsers}
              setCheckedUsers={setCheckedUsers}
              setSelectAllChecked={setSelectAllChecked}
              isActiveDeleteAllUsers={isActiveDeleteAllUsers}
            />
            <UserContent
              showSelectCheckbox={showSelectCheckbox}
              setShowSelectCheckbox={setShowSelectCheckbox}
              checkedUsers={checkedUsers}
              handleCheckboxChange={handleCheckboxChange}
              selectAllChecked={selectAllChecked}
              handleSelectAllChange={handleSelectAllChange}
              setCheckedUsers={setCheckedUsers}
            />
          </div>
          <UserFooter />
        </TabPanel>
        <TabPanel>
          <div className="box__shadow">
            <SubAdminHeader />
            <SubAdminContent />
          </div>
          <SubAdminFooter />
        </TabPanel>
        {configState.configs?.membership_enabled === Domain.TAA && (
          <>
            <TabPanel>
              <Tabs
                className="user__tab__container"
                selectedIndex={selfPacedTabIndex}
                onSelect={(index) => {
                  setSelfPacedTabIndex(index);
                  dispatch(setSelfPacedCurrentPage(1));
                }}
              >
                <TabList className="user__tab__list__section">
                  <Tab className="user__single__tab ">Self Paced Users</Tab>
                  <Tab className="user__single__tab mll">Free Users</Tab>
                  <Tab className="user__single__tab mll">
                    Certification Users
                  </Tab>
                </TabList>
                <TabPanel>
                  <div className="box__shadow">
                    <SelfPacedUserHeader rolesToShow="self_paced" />
                    <SelfPacedUserContent rolesToShow="self_paced" />
                  </div>
                  <SelfPacedUserFooter />
                </TabPanel>
                <TabPanel>
                  <div className="box__shadow">
                    <SelfPacedUserHeader rolesToShow="free" />
                    <SelfPacedUserContent rolesToShow="free" />
                  </div>
                  <SelfPacedUserFooter />
                </TabPanel>

                <TabPanel>
                  <div className="box__shadow">
                    <SelfPacedUserHeader rolesToShow="certification" />
                    <SelfPacedUserContent rolesToShow="certification" />
                  </div>
                  <SelfPacedUserFooter />
                </TabPanel>
              </Tabs>
            </TabPanel>

            <TabPanel>
              <div className="box__shadow">
                <MentorHeader />
                <MentorContent />
              </div>
              <MentorFooter />
            </TabPanel>

            <TabPanel>
              <div className="box__shadow">
                <TrialUserHeader />
                <TrialUserContent />
              </div>
              <TrialUserFooter />
            </TabPanel>
            <TabPanel>
              <div className="box__shadow">
                <Subscribers />
              </div>
            </TabPanel>
            <TabPanel>
              <div className="box__shadow">
                <ApplyNow />
              </div>
            </TabPanel>
            <TabPanel>{/* <LiveDataAaystNotifiedUsers/> */}</TabPanel>
          </>
        )}
      </Tabs>
      <DeleteModal
        showModal={deleteAllUserModal}
        setShowModal={setDeleteAllUserModal}
        loading={userState.deleteLoading}
        onClick={deleteUser}
        message={`You want to delete ${checkedUsers.length} users ? This action cannot be undone.`}
      />
    </div>
  );
};

export default UserAllTabs;
